module.exports = __webpack_public_path__ + "view/2019/img/5151EmpiraWhite@2x.png";